import { useEffect } from "react";
import CategoryView from "@/pages/category/components/CategoryView";

export default function CategoryTv() {
  useEffect(() => {
    document.title = "电视剧分类 - 黄色影院";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "黄色影院电视剧分类页，覆盖古装、都市、悬疑、科幻、医疗等多题材剧集，支持按类型、地区、年份、集数筛选，连载剧集一站追更。",
      );
    }
  }, []);

  return <CategoryView type="tv" />;
}